import { SupabaseClient } from '@supabase/supabase-js';
import camelcaseKeys from 'camelcase-keys';

import { Database, withLogs } from '@core';

export const fetchStudent = withLogs(async (supabaseClient: SupabaseClient<Database>, userId: string) => {
    const { data, error } = await supabaseClient.from('user_coaches').select().eq('user_id', userId).single();
    if (error) throw error;
    return data ? camelcaseKeys(data) : null;
}, 'fetchStudent');
